(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.service('rebateFormWindow', ['RebatePDFModel', function (RebatePDFModel) {
        return function (model, scope) {

            var homeAddress = {
                "Line1": model.contact.homeAddress.AddressLine,
                "Line2": "",
                "Suburb": model.contact.homeAddress.Locality,
                "StateCode": model.contact.homeAddress.State,
                "Postcode": model.contact.homeAddress.Postcode
            };
            var postalAddress = {
                "Line1": model.contact.postalAddress.AddressLine,
                "Line2": "",
                "Suburb": model.contact.postalAddress.Locality,
                "StateCode": model.contact.postalAddress.State,
                "Postcode": model.contact.postalAddress.Postcode
            };

            if( model.contact.postalAddressSameAsHome === 'Y' ) {
                postalAddress = homeAddress;
            }

            var medicareCardValidToDate = moment('01/' + model.personal.medicareExpiry, 'DD/MM/YYYY').clone().endOf('month').format('YYYY-MM-DD');
            

            var dependants = [];
            if( model.cover.memberType === 'Cpl' ) {
                addDependantPartner();
            }
            else if( model.cover.memberType === 'Fam' ) {
                addDependantPartner();
                addDependants();
            }
            else if( model.cover.memberType === 'SPFam' ) {
                addDependants();
            }

            function addDependantPartner() {
                dependants.push({
                    "Surname": model.personal.partner.partnerLastName,
                    "GivenName": model.personal.partner.partnerFirstName,
                    "Gender": getGender(model.personal.partner.partnerGender),
                    "DateOfBirth": model.personal.partner.partnerDOB,
                    "IsDependentChild": false
                });
            }
            function addDependants() {
                var dependant;
                if( model.personal.dependants.length > 0 ) {
                    for( var i = 0; i < model.personal.dependants.length; i++ ) {
                        dependant =  model.personal.dependants[i];
                        dependants.push({
                            "Surname": dependant.dependantLastName,
                            "GivenName": dependant.dependantFirstName,
                            "Gender": getGender(dependant.dependantGender),
                            "DateOfBirth": dependant.dependantDOB,
                            "IsDependentChild": true
                        });
                    }
                }
            }

            function getGender(value) {
                return (value == 'M') ? 'Male' : 'Female'
            }

            var rebateLevel;
            if( model.cover.governmentRebateIncomeTier == 0 ) {
                rebateLevel = 'NoChange';
            }
            else {
                rebateLevel = "Tier" + model.cover.governmentRebateIncomeTier; // Tier1, Tier2, Tier3;
            }


            var rebateFormData = {
                "RebateDeclarationFormType": "Automatic",
                "HealthFundName": joinFormPageData.siteName,
                "RebateCommencementDate": model.cover.coverStartDate,
                "ClaimantDetails": {
                    "ClaimantCoveredByPolicy": true,
                    "MedicareCardNumber": model.personal.medicareNumber,
                    "MedicareCardValidToDate": medicareCardValidToDate, // ???
                    "Surname": model.personal.medicareLastName,
                    "GivenName": model.personal.medicareFirstName + ' ' + model.personal.medicareInitial,
                    "Gender": getGender(model.personal.memberGender),
                    "DateOfBirth": model.personal.memberDOB,
                    "PostalAddress": postalAddress,
                    "HomeAddress": homeAddress,
                    "PhoneNumber": model.contact.phoneNumber[0].value
                },
                "AllPeopleOnPolicyEntitled": true,
                "RebateLevel": rebateLevel,
                "RebateDeclarationDate": model.cover.coverStartDate,
                "DependantDetails": dependants,
                "AdditionalFields": []
            };

            scope.displayGroups.rebateLoader = true;
            var newWindow = scope.rebateWindow = window.open('/static/views/join-form/rebate-pdf-opener.html','rebate-pdf', "left=100,top=100,width=600,height=700");

            RebatePDFModel.render(rebateFormData)
                .then(
                    function (data) {
                        newWindow.location = window.URL.createObjectURL(data);
                        scope.field.confirm.declareRebate.disabled = false;
                        scope.displayGroups.rebateLoader = false;
                    },
                    function (data) {
                        scope.field.confirm.declareRebate.disabled = false;
                        newWindow.close();
                        scope.formState.display.loadingRebate = false;
                        scope.displayGroups.rebateError = true;
                        scope.displayGroups.rebateLoader = false;
                    });
          

            /**
             * I know its a mixture between Native JS and jQuery, and I apologise for this.
             *
             * - Blanksy
             */
            /*var form = document.createElement("form");
            form.setAttribute("id", "governmentRebateForm");
            form.setAttribute("method", "post");
            form.setAttribute("action", "/api/v1/generate-rebate-declaration-render");
            form.setAttribute("enctype", "application/x-www-form-urlencoded");
            form.setAttribute("target", "formresult");

            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("name", "rebateDeclaration");
            hiddenField.setAttribute("value", JSON.stringify(rebateFormData));
            form.appendChild(hiddenField);

            document.body.appendChild(form);
            form.submit();
            $(form).remove();*/



        }
    }]);
})(jQuery, angular, window);
